import { ROUTE_BUILD_ACTION_PLAN } from '@/constants/routes';
import useIsMobile from '@/hooks/use-is-mobile';
import { IconPlus, Link } from '@cmpsr/components';
import { Link as ReactRouterLink } from 'react-router-dom';

export type AddNewActionLinkVariant = 'fixed' | 'responsiveMd' | 'responsiveLg';

type AddNewActionLinkProps = {
  variant: AddNewActionLinkVariant;
};

export default function AddNewActionLink({ variant }: AddNewActionLinkProps) {
  const isMobile = useIsMobile();
  const size = variant === 'fixed' || isMobile ? 'm' : 'l';

  return (
    <Link
      as={ReactRouterLink}
      to={ROUTE_BUILD_ACTION_PLAN}
      variant="accent"
      size={size}
      w={
        variant === 'fixed'
          ? '100%'
          : variant === 'responsiveMd'
          ? { base: '100%', md: 'max-content' }
          : { base: '100%', lg: 'max-content' }
      }
      leadingIcon={<IconPlus />}
      justifyContent="center"
      display="flex"
    >
      Add new action
    </Link>
  );
}
